import { GameState } from '../objects/GameState';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import { Diagnosis } from '../objects/Diagnosis';
import { Helpers } from '../objects/Helpers';
import initializeInteractiveCursor from 'src/games/shared/InteractiveCursorUtil';
import TranslateApi from 'src/utils/TranslateHelper';

export class ColorChangerInfoScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    map: Phaser.Tilemaps.Tilemap;
    correctDiagnosis: Diagnosis;

    constructor() {
        super({
            key: "ColorChangerInfoScene_" + Math.random(),
        });
    }

    preload(): void {
        // All assets were loaded in MainScene
        this.load.tilemapTiledJSON("color_changer_info_scene_map", require("/src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_color_changer_info_scene.json"));
    }

    create(): void {
        this.initialize();
        this.generateScene();
        initializeInteractiveCursor(this);
    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'color_changer_info_scene_map' });
        this.correctDiagnosis = GameState.current.correctDiagnosis;
    }

    generateScene() {
        let background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        background.setOrigin(0.5);
        background.setDepth(0);

        this.addObjects();
        Helpers.addNextButton(this);
        Helpers.addBackButton(this);
    }

    addObjects(): void {
        var translateString = "Diagnosis.Phaser.ColorChangerInfoScene.";
        var fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 10, backgroundColor: "#000000" };
        this.map.getObjectLayer("Scene").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000 " };
                var text = TranslateApi.translate(translateString + "text");
                var box = this.add.text(ob.x, ob.y, text, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(this.gameWidth/2 - box.displayWidth/2);
                this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
            else if (ob.name === "before") {
                var tube1 = this.add.image(ob.x, ob.y, "assets", "before");
                tube1.setOrigin(0);
                tube1.setDisplaySize(ob.width, ob.height);
                var before = TranslateApi.translate(translateString + "before");
                var tube1Label = this.add.text(0, tube1.getTopRight().y - 60, before , fontStyle).setDepth(1);
                tube1Label.setX(tube1.getCenter().x - tube1Label.width/2);
                this.add.image(tube1Label.x - 5, tube1Label.y - 5, "pixel").setDisplaySize(tube1Label.displayWidth + 10, tube1Label.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);

            }
            else if (ob.name === "after") {
                var tube2 = this.add.image(ob.x, ob.y, "assets", "after");
                tube2.setOrigin(0);
                tube2.setDisplaySize(ob.width, ob.height);
                var after = TranslateApi.translate(translateString + "after");
                var tube2Label = this.add.text(0, tube2.getTopRight().y - 60, after, fontStyle).setDepth(1);
                tube2Label.setX(tube2.getCenter().x - tube2Label.width/2);
                this.add.image(tube2Label.x - 5, tube2Label.y - 5, "pixel").setDisplaySize(tube2Label.displayWidth + 10, tube2Label.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/DiagnosisGame/scenes/ColorChangerInfoScene.ts